
import { UseFormRegister } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { Application } from '@/types/database.types';

interface IdentificationInfoProps {
  register: UseFormRegister<Partial<Application>>;
}

export const IdentificationInfo = ({ register }: IdentificationInfoProps) => {
  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-muted-foreground">Business Identification</h4>

      <div className="grid gap-4 md:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="ein">Employer Identification Number</Label>
          <Input 
            id="ein" 
            {...register('ein')} 
            placeholder="XX-XXXXXXX" 
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="year_founded">Year Founded</Label>
          <Input 
            id="year_founded" 
            {...register('year_founded')} 
            placeholder="YYYY" 
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="naics_code">NAICS Code</Label>
        <Input 
          id="naics_code" 
          {...register('naics_code')} 
          placeholder="Enter NAICS code" 
        />
      </div>
    </div>
  );
};

